import React from 'react';
import Dialog from '../../components/Dialog';
import { AlertCircleIcon } from 'lucide-react';

interface ConfirmationDialogProps {
    id: string;
    isOpen: boolean;
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    isSubmitting?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    id,
    isOpen,
    title,
    message,
    confirmText = 'Yes',
    cancelText = 'No',
    isSubmitting = false,
    onConfirm,
    onCancel
}) => {
    return (
        <Dialog
            id={id}
            isOpen={isOpen}
            onClose={onCancel}
            width="w-[450px]"
            padding="px-10 py-10"
            className="z-[60]"
            hideCloseButton={true}
            disableBackdropClick={true}
        >
            <div className="text-center">
                <div className="flex justify-center mb-4">
                    <div className="bg-white flex items-center justify-center mx-auto mb-4">
                        <AlertCircleIcon className="w-16 h-16 text-[#FF2C23]" />
                    </div>
                </div>
                <h3 className="text-heading font-heading mb-2">{title}</h3>
                <p className="text-text-secondary mb-8">{message}</p>

                <div className="flex justify-center gap-4">
                    <button
                        id={`btn-${id}-cancel`}
                        onClick={onCancel}
                        className="btn-secondary px-8 py-2"
                    >
                        {cancelText}
                    </button>
                    <button
                        id={`btn-${id}-confirm`}
                        onClick={onConfirm}
                        className="btn-primary px-8 py-2"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Processing...' : confirmText}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default ConfirmationDialog;
